function _s(o, i, p, l) {
  void 0 === i && (i = 400),
    void 0 === l && (l = !1),
    (o.style.overflow = "hidden"),
    l && (o.style.display = "block");
  var n,
    t = window.getComputedStyle(o),
    s = parseFloat(t.getPropertyValue("height")),
    a = parseFloat(t.getPropertyValue("padding-top")),
    r = parseFloat(t.getPropertyValue("padding-bottom")),
    y = parseFloat(t.getPropertyValue("margin-top")),
    d = parseFloat(t.getPropertyValue("margin-bottom")),
    g = s / i,
    m = a / i,
    h = r / i,
    u = y / i,
    x = d / i;
  window.requestAnimationFrame(function t(e) {
    void 0 === n && (n = e);
    e -= n;
    l
      ? ((o.style.height = g * e + "px"),
        (o.style.paddingTop = m * e + "px"),
        (o.style.paddingBottom = h * e + "px"),
        (o.style.marginTop = u * e + "px"),
        (o.style.marginBottom = x * e + "px"))
      : ((o.style.height = s - g * e + "px"),
        (o.style.paddingTop = a - m * e + "px"),
        (o.style.paddingBottom = r - h * e + "px"),
        (o.style.marginTop = y - u * e + "px"),
        (o.style.marginBottom = d - x * e + "px")),
      i <= e
        ? ((o.style.height = ""),
          (o.style.paddingTop = ""),
          (o.style.paddingBottom = ""),
          (o.style.marginTop = ""),
          (o.style.marginBottom = ""),
          (o.style.overflow = ""),
          l || (o.style.display = "none"),
          "function" == typeof p && p())
        : window.requestAnimationFrame(t);
  });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
  0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
  (HTMLElement.prototype.slideUp = function (t, e) {
    _s(this, t, e);
  }),
  (HTMLElement.prototype.slideDown = function (t, e) {
    _s(this, t, e, !0);
  });

class Header extends HTMLElement {
  constructor() {
    super();

    this.lastPosition = window.scrollY;

    this.updateHeightHeaderGroup();
    this.updateHeight();
    this.menuOpen = false;

    this.querySelector(".header__back-list").addEventListener(
      "click",
      this.toggleSubLinklistSub.bind(this)
    );

    this.closest(".shopify-section-group-header-group").classList.add(
      "header-shopify-section"
    );


    window.addEventListener("scroll", this.updateHeightHeaderGroup.bind(this));
    window.addEventListener("scroll", this.updateHeight.bind(this));
    window.addEventListener("resize", this.updateHeightHeaderGroup.bind(this));

    window.addEventListener("resize", this.checkDrawer.bind(this));

    this.checkDrawer();

    this.querySelector("[data-open-drawer]").addEventListener(
      "click",
      this.openDrawer.bind(this)
    );

    document.addEventListener(
      "click",
      function (e) {
        if (
          !e.target.closest("drawer-menu") &&
          !e.target.closest("[data-open-drawer]")
        ) {
          this.closeDrawer();
        }
      }.bind(this)
    );

    document.querySelector("[data-close-drawer]").addEventListener(
      "click",
      function (e) {
        this.closeDrawer();
      }.bind(this)
    );

    this.querySelectorAll("[data-dropdown]").forEach((elem) => {
      elem.addEventListener("click", this.initDropdown.bind(this));
    });

    this.querySelector("mega-menu").addEventListener(
      "click",
      this.activeMegaMenu.bind(this)
    );

    document.addEventListener(
      "click",
      function (e) {
        if (
          !e.target.closest("mega-menu") &&
          !e.target.closest("[data-dropdown]") &&
          this.menuOpen
        ) {
          this.desactiveMegaMenu();
          this.closeDropdown();
        }
      }.bind(this)
    );

    this.querySelectorAll("[data-sub-handle]").forEach((elem) => {
      elem.addEventListener("click", this.switshSubLinks.bind(this));
    });

    this.querySelectorAll("[data-sub-handle-one]").forEach((elem) => {
      elem.addEventListener("click", this.toggleSubLinklist.bind(this));
    });
  }

  toggleSubLinklist(e) {
    let handle = e.currentTarget.dataset.subHandleOne;
    this.querySelectorAll("[data-sub-handle-one]").forEach((elem) => {
      elem.classList.remove("active");
    });

    document.querySelector(".header__back-list").classList.toggle("active");

    e.currentTarget.classList.add("active");

    this.querySelectorAll("[data-sub-handle-two]").forEach((elem) => {
      elem.classList.remove("active");
    });

    this.querySelector(`[data-sub-handle-two="${handle}"]`).classList.add(
      "active"
    );
  }

  checkDrawer() {
    if (window.innerWidth >= 1100) {
      this.closeDrawer();
      if (document.querySelector(".location__container--mob").innerHTML != "") {
        document.querySelector(".location__container--desk").innerHTML =
          document.querySelector(".location__container--mob").innerHTML;
        document.querySelector(".location__container--mob").innerHTML = "";
      }
    } else {
      if (
        document.querySelector(".location__container--desk").innerHTML != ""
      ) {
        document.querySelector(".location__container--mob").innerHTML =
          document.querySelector(".location__container--desk").innerHTML;
        document.querySelector(".location__container--desk").innerHTML = "";
      }
    }
  }

  toggleSubLinklistSub() {
    this.querySelector(".header__back-list").classList.remove("active");
    this.querySelectorAll("[data-sub-handle-two]").forEach((elem) => {
      elem.classList.remove("active");
    });
  }

  openDrawer() {
    this.querySelector("drawer-menu").classList.add("active");
    document.body.classList.add("overflow-hidden");
    document.body.classList.add("drawer-body-open");
    this.querySelector(".header__left").classList.add("drawer-open");
  }

  closeDrawer() {
    this.querySelector("drawer-menu").classList.remove("active");
    if (
      window.innerWidth < 1100 &&
      document.body.classList.contains("overflow-hidden")
    ) {
      document.body.classList.remove("overflow-hidden");
    }

    if (
      window.innerWidth >= 1100 &&
      document.querySelector(".mega-menu__container.active") == null
    ) {
      document.body.classList.remove("overflow-hidden");
    }
    document.body.classList.remove("drawer-body-open");
    this.querySelector(".header__left").classList.remove("drawer-open");
  }

  initDropdown(e) {
    this.activeMegaMenu(e);

    document.querySelectorAll(`[data-dropdown-handle]`).forEach((elem) => {
      elem.classList.remove("active");
    });

    document.querySelectorAll(`[data-main-handle]`).forEach((elem) => {
      elem.classList.remove("active");
    });

    e.currentTarget.classList.add("active");

    if (e.currentTarget.dataset.mainHandle != undefined) {
      var dropdown = e.currentTarget.dataset.mainHandle;
      document
        .querySelector(`[data-dropdown-handle="${dropdown}"]`)
        .classList.add("active");
    }

    document.querySelector("mega-menu").classList.add("active");
    document.body.classList.add("overflow-hidden");
  }

  closeDropdown(e) {
    document.querySelector("mega-menu").classList.remove("active");
    document.body.classList.remove("overflow-hidden");
    console.log(this.menuOpen);
    if (this.menuOpen == true) {
      document.querySelectorAll(`.header__left--li`).forEach((elem) => {
        elem.classList.remove("active");
      });
    }
  }

  activeMegaMenu(e) {
    this.menuOpen = true;
    console.log(e.currentTarget);
    document.querySelector("mega-menu").classList.add("active");
    document.body.classList.add("overflow-hidden");
  }

  desactiveMegaMenu(e) {
    this.menuOpen = false;
    document.querySelector("mega-menu").classList.remove("active");
    document.querySelectorAll(`[data-dropdown-handle]`).forEach((elem) => {
      elem.classList.remove("active");
    });

    document.querySelectorAll(`.header__left--li`).forEach((elem) => {
      elem.classList.remove("active");
    });
    document.body.classList.remove("overflow-hidden");
  }

  switshSubLinks(e) {
    let subLinks = e.currentTarget
      .closest(".mega-menu__item")
      .querySelectorAll(`[data-dropdown-sub-handle]`);
    subLinks.forEach((elem) => {
      elem.classList.remove("active");
    });

    e.currentTarget
      .closest(".mega-menu__item")
      .querySelectorAll(`[data-sub-handle]`)
      .forEach((elem) => {
        elem.classList.remove("active");
      });

    e.currentTarget.classList.add("active");
    let subLinksActive = document.querySelector(
      `[data-dropdown-sub-handle="${e.currentTarget.dataset.subHandle}"]`
    );
    subLinksActive.classList.add("active");
  }

  updateHeightHeaderGroup(e, elem) {
    let bannerHeight = 0;
    if (document.querySelector(".section-scrolling-content") != null) {
      bannerHeight = document.querySelector(
        ".section-scrolling-content"
      ).offsetHeight;
    }
    let headerHeight = this.parentNode.offsetHeight;

    let headerGroupHeight = headerHeight;
    if (window.scrollY >= bannerHeight) {
      headerGroupHeight = headerHeight;
    } else {
    }

    document.documentElement.style.setProperty(
      "--banner-height",
      `${bannerHeight}px`
    );

    document.documentElement.style.setProperty(
      "--header-group-height",
      `${headerGroupHeight}px`
    );
    if (window.scrollY >= 600) {

      this.parentNode.parentNode.classList.add("header-fixed");
      document.documentElement.style.setProperty(
        "--header-fix-height",
        `${headerGroupHeight}px`
      );
      document.querySelector("body").classList.add("header-fixed");


    } else if (window.scrollY < 510) {
      this.parentNode.parentNode.classList.remove("header-fixed");
      document.documentElement.style.setProperty("--header-fix-height", `0px`);
      document.querySelector("body").classList.remove("header-fixed");
    }

    if (window.scrollY >= 1100) {
      this.closeDrawer();
    }

  }

  updateHeight(e) {
    if (window.scrollY >= 40) {
      this.parentNode.classList.add("banner-hide");
    } else {
      this.parentNode.classList.remove("banner-hide");
      if (document.querySelector("#section-banner")) {
        document.querySelector("#section-banner").classList.remove("hidden");
      }
    }

    this.updateHeightHeaderGroup(e);
    let currentScroll = window.scrollY;
    if (window.scrollY >= 600) {
      if (document.querySelector('.collection-filters__custom')) {
        if (currentScroll > this.lastPosition) {
          this.parentNode.parentNode.classList.remove("header-fixed");
          document.documentElement.style.setProperty("--header-fix-height", `0px`);
          document.querySelector("body").classList.remove("header-fixed");
        } else {
          this.parentNode.parentNode.classList.add("header-fixed");
          document.querySelector("body").classList.add("header-fixed");
        }
      }

      this.lastPosition = currentScroll;
    }


  }
}
customElements.define("header-js", Header);